<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <v-btn text color="warning" :to="{ name: 'bookings' }" class="ma-0 mb-2"><v-icon left>arrow_back</v-icon> Court Hire</v-btn>
                <!-- <h1 class="grey--text lighten-3 mb-2">Court Hire History</h1> -->
                <v-card class="elevation-12">
                    <v-card-title>
                        Court Hire History
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" clearable single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table sort-by="booking_from" :sort-desc="true" :search="search" :loading="mybookingsLoading" :items-per-page="10" :headers="headers" :items="mybookings" item-key="b_id" class="elevation-1">
                        <template slot="item" slot-scope="props">
                            <tr>
                                <td class="text-left">#{{ props.item.b_id }}</td>
                                <td class="text-left">{{ props.item.venue_name }}</td>
                                <td class="text-left">{{ props.item.sport_name }}</td>
                                <td class="text-left">{{ moment(props.item.booking_from).format('DD/MM/YYYY HH:mm') }}</td>
                                <td class="text-left">{{ moment(props.item.booking_to).format('DD/MM/YYYY HH:mm') }}</td>
                                <td class="text-left">{{ props.item.duration }}</td>
                                <td class="text-left">{{ props.item.type_name }}</td>
                                <!-- <td class="text-left">{{ props.item.option_name }}</td> -->
                                <td class="text-left">{{ props.item.space_name }}</td>
                                <td class="text-right">
                                    <div v-if="moment().isBefore(props.item.booking_from)">
                                        <v-btn small color="secondary" :href="genGoogLinkCal(props.item)" target="_blank" class="btnCal ma-2"><i class="fas fa-calendar-plus"></i>Add to Google Calendar</v-btn>
                                        <v-btn small color="primary" @click="genICal(props.item)" class="btnCal my-1"><i class="fas fa-calendar-plus pr-2"></i>Add to Apple Calendar</v-btn>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Bookings Yet
                            </div>
                        </template>
                        <template slot="no-results">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Results found for "{{ search }}"
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from './_store';
import moment from 'moment';
import { downloadIcs, googleCalendarUrl } from '@shared/calendar';

export default {
    name: 'MyBookingModule',
    components: {
        //
    },
    data () {
        return {
            moment: moment,
            search: '',
            headers: [
                { text: 'Booking #', value: 'b_id' },
                { text: 'Venue', value: 'venue_name' },
                { text: 'Sport', value: 'sport_name' },
                { text: 'Start', value: 'booking_from'},
                { text: 'End', value: 'booking_to' },
                { text: 'Duration', value: 'duration' },
                { text: 'Type', value: 'type_name' },
                // { text: 'Option', value: 'option_name' },
                { text: 'Space', value: 'space_name' },
                { text: 'Actions', value: '', align: 'right', sortable: false }
            ],
        }
    },
    computed: {
        mybookingsLoading(){
            return this.$store.getters['booking/bookingStatus'] == 'loading';
        },
        mybookings(){
            return this.$store.getters['booking/mybookings'];
        },
    },
    methods: {
        calendarEvent(booking) {
            return {
                uid: booking.b_id,
                title: this.appNameUrls.client + " - Booking",
                start: booking.booking_from,
                end: booking.booking_to,
                location: booking.venue_name,
                descriptionLines: [
                    "Venue: " + booking.venue_name,
                    "Sport: " + booking.sport_name,
                    "Type: " + booking.type_name,
                    "Option: " + booking.option_name,
                    "Space: " + booking.space_name,
                    "Duration: " + booking.duration,
                ],
                timezone: this.lmpTz,
                filename: "booking.ics",
            };
        },
        genGoogLinkCal(booking) {
            return googleCalendarUrl(this.calendarEvent(booking));
        },
        genICal(booking) {
            downloadIcs(this.calendarEvent(booking));
        },
    },
    beforeCreate(){
        // this.$store.dispatch('user/userRequest');
        if(_.isEmpty(this.$store.getters['booking/mybookings'])){
            this.$store.dispatch('booking/mybookingsRequest');
        }
    }
};
</script>

<style scoped>
@media screen and (max-width: 767px) {
    .btnCal {
        display: block !important;
        padding-top: 7px !important;
        padding-bottom: 7px !important;
    }
}
</style>
